import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { FormSelectChoice, InputSelectComponentProps } from '@sheerid/jslib';
import { InputSelectComponent } from '../../FormInputs/InputSelect/InputSelectComponent';


type compareLabelReturn = 1 | -1;

export const compareLabel = (a: FormSelectChoice<any>, b: FormSelectChoice<any>): compareLabelReturn => {
    let sortValue: compareLabelReturn;

    try {
        sortValue = a.label.toUpperCase() > b.label.toUpperCase() ? 1 : -1;
    } catch (e) {
        sortValue = 1;
    }

    return sortValue;
};

export const SortByLabel = (choices: FormSelectChoice<any, string>[]): FormSelectChoice<any, string>[] => choices.sort(compareLabel);

const FirstResponderStatusComponent = ({
    value,
    isErrored,
    options,
    onChange,
    onKeyDown = undefined,
    placeholder,
}: InputSelectComponentProps) => {
    return (
        <div className="sid-field sid-first-responder-status">
            <div className="sid-l-space-top-md" />
            <label htmlFor="sid-first-responder-status">
                <div className="sid-field__label sid-field__label--required sid-first-responder-status__label sid-l-space-btm-sm">
                    <FormattedHTMLMessage
                        id="status"
                        defaultMessage="Status"
                    />
                </div>
            </label>
            <InputSelectComponent
                fieldId={'status'}
                inputId="sid-first-responder-status"
                isErrored={isErrored}
                options={SortByLabel(options)}
                onChange={(status: FormSelectChoice) => onChange(status)}
                onKeyDown={onKeyDown}
                value={value}
                placeholder={placeholder}
            />
            {
                isErrored ? (
                    <div className="sid-field-error">
                        <FormattedHTMLMessage
                            id="errorId.invalidStatus"
                            defaultMessage="Invalid first responder status"
                        />
                    </div>
                ) : null
            }
        </div>
    );
};

export { FirstResponderStatusComponent };
